import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'inventory';

const sendDeviceInventoryCommandByInventoryId = async ({
  inventoryId,
  simcardInventoryId,
  command,
  channel,
  contractCode
}) => {
  const body = {
    inventoryId,
    simcardInventoryId,
    command,
    channel,
    contractCode
  };

  const method = 'POST';
  const url = `${USE_CASE_URL}/${inventoryId}`;

  const json = await request({ method, url, body });
  return json;
};

export default sendDeviceInventoryCommandByInventoryId;
